import { render } from "./OnlineChart.vue?vue&type=template&id=8d99ae76"
import script from "./OnlineChart.vue?vue&type=script&lang=js"
export * from "./OnlineChart.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\ssradius\\frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__